import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BASE_URL, END_POINTS } from 'src/app/utility/APIConstants';
import { IPurchaseOrder } from '../master/models/purchaseorder.model';
@Injectable({ providedIn: 'root' })
export class PurchaseOrderService {
  public selectedPurchaseOrder: IPurchaseOrder = null;
  constructor(private _http: HttpClient) { }
  public fetchPurchaseOrderEntries(): Observable<any> {
    return this._http.get(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH);
  }
  public createPurchaseOrderEntry(payload): Observable<any> {
    return this._http.post(BASE_URL + END_POINTS.PURCHASE_ORDER.CREATE, payload);
  }
  public updatePurchaseOrderEntry(payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.UPDATE(payload.purchaseOrderId), payload);
  }
  // users
  getAllUsers() {
    return this._http.get<any[]>(`${environment.apiBase}/api/user/getall`);
  }
  public fetchPOById(id): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_BY_ID(id));
  }
  getAllTerms() {
    return this._http.get<any>(BASE_URL + END_POINTS.TERMS.FETCH);
  }
  getAllTermsByType(type:string) {
    return this._http.get<any>(BASE_URL + END_POINTS.TERMS.FETCH_BY_TYPE(type));
  }
  fetchPurchaseOrderBySupplier(supplierKey): Observable<any>{
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_BY_SUPPLIER(supplierKey));
  }
  public approvePO(id: any): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.APPROVE(id), {});
  }

  public rejectPO(poId: any, payload): Observable<any> {
      return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.REJECT(poId), payload);
  }

  public forceClose(poId: any, payload): Observable<any> {
    return this._http.put(BASE_URL + END_POINTS.PURCHASE_ORDER.FORCECLOSE(poId), payload);
  }

  public printPO(id: number){
    return this._http.get(BASE_URL + END_POINTS.PURCHASE_ORDER.PRINT(id), { responseType: 'blob' });
  }

  public fetchPOForDO(siteKey): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_FOR_DO+ '?'+siteKey);
  }

  public fetchPOSitesForDO(): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_SITE_FOR_DO);
  }

  public fetchProductsForDO(params): Observable<any> {
    return this._http.get<any>(BASE_URL + END_POINTS.PURCHASE_ORDER.FETCH_PRODUCT_FOR_DO+ '?' + params);
  }

}